import React, { Component } from "react";
import Slider from "react-slick";
import { Link } from 'react-router-dom'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import hero1 from '../../images/slider/slide-1.jpg'
import hero2 from '../../images/slider/slide-2.jpg'
import hero3 from '../../images/slider/slide-3.jpg'
import hero4 from '../../images/slider/slide-4.jpg'

class Hero3 extends Component {
    render() {
        // Configuración del slider
        var settings = {
            dots: false,
            arrows: true,
            speed: 1200,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 2500,
            fade: true
        };

        // Estilos en línea
        const styles = {
            heroContainer: {
                width: '100%',
                height: '50vh', // Altura por defecto para móviles
            },
            heroContainerMd: {
                height: '60vh', // Altura para pantallas medianas y superiores
            },
            slideInner: {
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center', // Centra el contenido verticalmente
                justifyContent: 'center', // Centra el contenido horizontalmente
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }
        };

        return (
            <section className="wpo-hero-slider">
                <div 
                    className="hero-container" 
                    style={{
                        ...styles.heroContainer,
                        ...(window.innerWidth >= 768 && styles.heroContainerMd) // Aplica 70vh en pantallas md y superiores
                    }}
                >
                    <div className="hero-wrapper">
                        <Slider {...settings}>
                            <div className="hero-slide">
                                <div 
                                    className="slide-inner slide-bg-image" 
                                    style={{ 
                                        ...styles.slideInner,
                                        backgroundImage: `url(${hero1})`
                                    }}
                                >
                                    <div className="container">
                                        <div className="slide-content">
                                            {/* Contenido del slide */}
                                        </div>
                                    </div>
                                </div>
                            </div> 

                            <div className="hero-slide">
                                <div 
                                    className="slide-inner slide-bg-image" 
                                    style={{ 
                                        ...styles.slideInner,
                                        backgroundImage: `url(${hero2})`
                                    }}
                                >
                                    <div className="container">
                                        <div className="slide-content">
                                            {/* Contenido del slide */}
                                        </div>
                                    </div>
                                </div> 
                            </div> 

                            <div className="hero-slide">
                                <div 
                                    className="slide-inner slide-bg-image" 
                                    style={{ 
                                        ...styles.slideInner,
                                        backgroundImage: `url(${hero3})`
                                    }}
                                >
                                    <div className="container">
                                        <div className="slide-content">
                                            {/* Contenido del slide */}
                                        </div>
                                    </div>
                                </div> 
                            </div> 

                            <div className="hero-slide">
                                <div 
                                    className="slide-inner slide-bg-image" 
                                    style={{ 
                                        ...styles.slideInner,
                                        backgroundImage: `url(${hero4})`
                                    }}
                                >
                                    <div className="container">
                                        <div className="slide-content">
                                            {/* Contenido del slide */}
                                        </div>
                                    </div>
                                </div> 
                            </div> 
                        </Slider>
                    </div>
                </div>
            </section>
        );
    }
}

export default Hero3;